import { useDateRangeDisplayText, type CalendarDateRange } from '../../DateRangePicker';
import Widget from '../../Widget';
import { LargestDepositRow, LargestWithdrawalRow, TotalBalanceChangeRow, TotalTransactionsRow } from '../rows';

import type { ColumnTable } from 'arquero';

export interface IDepositoryAccountSummaryProps {
  transactions: ColumnTable | null;
  currentBalance?: number;
  dateRange: CalendarDateRange;
  className?: string;
}

const DepositoryAccountSummary = ({
  transactions,
  currentBalance,
  dateRange,
  className,
}: IDepositoryAccountSummaryProps) => {
  const dateRangeDisplayText = useDateRangeDisplayText(dateRange);

  return (
    <Widget className={className}>
      <Widget.Header
        title="Summary"
        trailing={<span className="text-tertiary text-xs font-medium">{dateRangeDisplayText}</span>}
      />

      <Widget.Body className="pb-2 pt-1">
        <TotalTransactionsRow transactions={transactions} dateRange={dateRange} />
        <LargestDepositRow transactions={transactions} dateRange={dateRange} colored={true} />
        <div className="border-tertiary border-b">
          <LargestWithdrawalRow transactions={transactions} dateRange={dateRange} colored={true} showSign={true} />
        </div>
        <TotalBalanceChangeRow
          transactions={transactions}
          currentBalance={currentBalance}
          dateRange={dateRange}
          showSign={true}
        />
      </Widget.Body>
    </Widget>
  );
};

export default DepositoryAccountSummary;
